import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-historico-produto',
  templateUrl: './historico-produto.component.html',
  styleUrls: ['./historico-produto.component.css']
})
export class HistoricoProdutoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
